import { useEffect, useRef, useState } from "react";

export const useViewportMaxHeight = (isOpen: boolean,dependencies: unknown[] = [],minHeight = 150,bottomMargin = 10, maxHeightLimit: number | null = null) => {
    const ref = useRef<HTMLDivElement>(null);
    const [maxHeight, setMaxHeight] = useState<number | null>(null);

    useEffect(() => {
        if (!isOpen) {
            setMaxHeight(null);
            return;
        }

        const element = ref.current;
        if (!element) return;
        let rafId: number | null = null;
        const updateMaxHeight = () => {
            rafId = null;
            const rect = element.getBoundingClientRect();
            const available = window.innerHeight - rect.top - bottomMargin;
            let nextHeight = Math.max(minHeight,available);
            if (maxHeightLimit !== null) {
                nextHeight = Math.min(nextHeight,maxHeightLimit);
            }
            setMaxHeight(nextHeight);
        };

        const scheduleUpdate = () => {
            if (rafId !== null) return;
            rafId = requestAnimationFrame(updateMaxHeight);
        };

        updateMaxHeight();
        window.addEventListener("resize", scheduleUpdate);
        window.addEventListener("scroll", scheduleUpdate, {
            passive: true,
        });

        return () => {
            window.removeEventListener("resize", scheduleUpdate);
            window.removeEventListener("scroll", scheduleUpdate);
            if (rafId !== null) cancelAnimationFrame(rafId);
        };
    }, [isOpen, minHeight, bottomMargin, ...dependencies]);
    return {ref,maxHeight};
};